import { FormControlViewModelType } from '../../view-model/FormControlViewModel';

import updateCheckboxGroup from './checkGroup';
import updateRadioGroup from './radioGroup';

export const inputUpdaters = {
  [FormControlViewModelType.CHECKBOX_GROUP]: updateCheckboxGroup,
  [FormControlViewModelType.RADIO_GROUP]: updateRadioGroup,
};
